<template>
  <div class="comment-panel">
    <a-collapse v-model="activeKeys" :bordered="false">
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel key="1" class="comment-item-panel">
        <span slot="header">
          <a-badge :count="commentCount"><span class="head-example">评论</span></a-badge>
        </span>
        <comment ref="comment" :mode="mode" :source-id="sourceId" @setCount="setCount" />
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import Comment from '@/components/comment/Comment';

export default {
  name: 'CommentPanel',
  components: { Comment },
  props: {
    activeKey: {
      type: Array[String],
      default() {
        return ['1'];
      }
    },
    sourceId: {
      type: Number,
      default: null
    },
    mode: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeKeys: [],
      commentCount: 0
    };
  },
  watch: {
    activeKey: {
      immediate: true,
      handler(val) {
        this.activeKeys = val;
      }
    }
  },
  methods: {
    onAddComment() {
      if (!this.activeKeys.includes('1')) {
        this.activeKeys.push('1');
      }
      this.$nextTick(() => {
        this.$refs['comment'].onAddComment();
      });
    },
    setCount(num) {
      this.commentCount = num;
    },
    setKey() {
      this.$nextTick(() => {
        this.$refs.comment.setKey();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.comment-panel {
  border-top: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 0 0 0;
  position: relative;
  overflow: visible;
}
.comment-item-panel {
  border-radius: 4px;
  border: 0;
  background: #fff;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.head-example {
  display: inline-block;
  padding-right: 8px;
  font-weight: 500;
  font-size: 15px;
}
.collapse-button {
  font-size: 13px;
  color: #1890ff;
  margin-left: 8px;
  padding: 0 4px;
}
:deep(.ant-badge-count) {
  height: 14px;
  min-width: 14px;
  line-height: 14px;
  font-size: 8px;
  padding: 0 3px;
  background-color: #1890ff;
}

// 确保collapse组件不会限制tooltip显示
:deep(.ant-collapse) {
  overflow: visible;
}

:deep(.ant-collapse-content) {
  overflow: visible;
}

:deep(.ant-collapse-content-box) {
  overflow: visible;
}
</style>
